import React, { Component } from 'react'
import { Select } from '@driftt/tide-selects'
import { getContactProperties } from 'api/imports'
import { omit, find, propEq, forEachObjIndexed } from 'ramda'

class ImportMappingTableRows extends Component {

  state = {
    currentContactProperties: null,
    hasChosenWrong: false,
    incorrectChoice: null
  }

  componentDidMount() {
    this.getContactProperties()
  }

  getContactProperties = async () => {
    try {
      const { data } = await getContactProperties()

      this.setState({
        currentContactProperties: data
      })
    } catch (e) {
      console.log(e)
    }
  }

  getCleanedState = (state) => {
    return omit(['currentContactProperties', 'hasChosenWrong', 'incorrectChoice'], state)
  }


  updateField = ({value}, rowHeader) => this.setState(prevState => {
    if (!Object.values(this.getCleanedState(prevState)).includes(value)) {
      return {
        [rowHeader]: value,
        hasChosenWrong: false,
        incorrectChoice: null
      }
    } else {
      return {
        hasChosenWrong: !prevState.hasChosenWrong,
        incorrectChoice: value
      }
    }
  }, this.triggerChange)


  triggerChange = () => {
    const { onChange } = this.props

    const headerMap = {}

    forEachObjIndexed((value, key) => {
      headerMap[value] = key
    }, this.getCleanedState(this.state))
    
    onChange(headerMap)
    
  }

  selectRowSample = (value) => {
    const { upload } = this.props

    if (!value) return null

    return upload.sampleData[value][0]
  }

  determineContactProperty = ({ header }) => {
    return find(propEq('label', header))
  }

  renderRows = () => {
    const { upload } = this.props
    const { currentContactProperties, hasChosenWrong, incorrectChoice } = this.state

    const driftProperties = currentContactProperties.map(property => ({
      label: property.displayName,
      value: property.name
    }))

    
    return upload.columnNames.map((row, i) => {
      const selectValue = driftProperties.filter(({ value }) => value === this.state[row])
  
      return (
        <tr>
          <td>{row}</td>
          <td>{this.selectRowSample(this.state[row] ? row : null)}</td>
          <td className="drift-property-select-cell">
            {(!!hasChosenWrong && row === incorrectChoice) &&
              <div className="incorrect-choice-warning">Sorry, but you can only select 1 instance of a Drift property per CSV upload</div>
            }
            <Select 
              options={driftProperties} 
              value={selectValue} 
              onChange={(event) => this.updateField(event, row)} 
              clearable={false} 
            />
          </td>
        </tr>
      )
    })
  }
  
  render() {
    const { currentContactProperties } = this.state
    return (
      <tbody>
        {!!currentContactProperties && this.renderRows()}
      </tbody>
    )
  }
}

export default ImportMappingTableRows
